import { useViewsContext } from '@cs-cms/state-management';
import { useCpsDialog } from '../../../common/useCpsDialog';

interface UseSystemViewSelectionProps {
  views: any[];
  translate: (key: string) => string;
}

export const useSystemViewSelection = ({ views, translate }: UseSystemViewSelectionProps) => {
  const {
    selectedView,
    setSelectedView,
    hasUnsavedChanges,
    setHasUnsavedChanges,
    selectedViewData,
    editingViewState,
    onUpdateView
  } = useViewsContext();
  const { showDialog } = useCpsDialog();

  const systemViews = views.filter(view => !view.isPrivate);

  const isSelectedViewValid = systemViews.some(view => view.id === selectedView);
  if (systemViews.length > 0 && (!selectedView || !isSelectedViewValid)) {
    setSelectedView?.(systemViews[0].id);
  }

  const handleViewChange = (event: any) => {
    const newViewId = event.value.id;

    if (hasUnsavedChanges) {
      showDialog({
        title: translate('custom.settings.adminCenter.systemViewManagement.unsavedChangesTitle'),
        message: translate('custom.settings.adminCenter.systemViewManagement.unsavedChangesMessage'),
        confirmButtonLabel: translate('custom.common.discard'),
        discardButtonLabel: translate('custom.common.cancel'),
        onConfirm: confirmed => {
          if (confirmed && setSelectedView) {
            setHasUnsavedChanges?.(false);
            setSelectedView(newViewId);
          }
        }
      });
    } else if (setSelectedView) {
      setSelectedView(newViewId);
    }
  };

  return {
    systemViews,
    selectedView,
    hasUnsavedChanges,
    selectedViewData,
    editingViewState,
    onUpdateView,
    setHasUnsavedChanges,
    handleViewChange
  };
};
